import React from 'react';

import ReleaseList from '../../components/ReleaseList';
import { getGenreById } from '../../actions/genre';
import { releasesByGenre } from '../../actions/release';
import { releasesByGenreList } from '../../selectors';

function Genre(props) {
  return (
    <ReleaseList
      title="Mp3Caprice - {category} Music"
      description="{category} mp3 music at Mp3Caprice. Discover, buy and download high quality tunes for reasonable prices."
      pathPrefix="genre"
      backToListTitle="All genres"
      mapState={(store, componentProps) => ({
        currentCategory: store.genres.data[componentProps.match.params.id],
        currentCategoryLoading: store.genres.loading,
        categoryItems: store.genres,
        categoryReleaseList: releasesByGenreList(store, componentProps),
      })}
      mapDispatch={{
        loadCategoryById: getGenreById,
        loadReleasesByCategory: releasesByGenre,
      }}
      {...props}
    />
  );
}

export default Genre;
